import axios, { AxiosResponse } from "axios";
import {ICategory} from "/react4xp/parts/manage-reestr-list/manage-reestr-list.type";

/**
 * Получение списка КОГД
 */
export const getTaxOrg = (): Promise<AxiosResponse<any[]>> => {
    return axios.get(`/services/isnaportal/open-api/tax-org/search`, {
        params: {
            levels: '1,2'
        }
    });
};

/**
 * Список реестров (категорий)
 */
export const documentHistoryCategories = (): Promise<AxiosResponse<ICategory[]>> => {
    return axios.get<ICategory[]>(`/services/isnaportal/open-api/admin/document-history/categories`, {
        params: {
            isReestr: true,
        }
    });
};
